// Split VERBATIM from utils/datetime-comprehensive.js (ESM barrel split).
import { DateTime } from 'luxon';
import { BUSINESS_TIMEZONE } from './dateTimeCore';

export const FORMATS = {
  API: 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'',
  DISPLAY: DateTime.DATETIME_MED_WITH_SECONDS,
  DATE_ONLY: DateTime.DATE_MED,
  TIME_ONLY: DateTime.TIME_SIMPLE,
  ISO: 'yyyy-MM-dd\'T\'HH:mm:ss.SSSZ',
  LEGACY: 'yyyy-MM-dd HH:mm:ss'
};

// Export timezone constants

export const TIMEZONES = {
  UTC: 'utc',
  BUSINESS: BUSINESS_TIMEZONE
};

/**
 * Convert UTC timestamp to user's local timezone for display
 * @param {string|Date} utcTimestamp - UTC timestamp (ISO string or Date object)
 * @param {string} format - Luxon format string (default: 'MMM d, yyyy \'at\' h:mm a')
 * @returns {string} - Formatted string in user's local timezone
 */
